import { MICRO_CHECKBOX, THREED_LIFT_TEN, THREED_LIFT_TEN_INPUT } from "../4-one-of-one/_selectors";
import {
	OUTLINE_REMOVE_BUTTON,
	SWATCH_THREADS,
	SWATCH_THREADS_MINUS_OUTLINE,
} from "../constants/selectors";
import selectAllElements from "../dom/selectAllElements";
import selectSingleElement from "../dom/selectSingleElement";

function swatchThreadsSetup() {
	const threads = selectAllElements(SWATCH_THREADS);
	const threeD = selectSingleElement<HTMLDivElement>(THREED_LIFT_TEN);
	const threadSwatchState = new Map();
	const microCheckbox = selectSingleElement<HTMLDivElement>(MICRO_CHECKBOX);
	let prevColorName = "";
	let prevIdentifierClass = "";

	// We need to add a listenter to micro, so that when it's clicked we need to clear the threadSwatchState map and unset the checked property of the swatch elements.
	microCheckbox?.addEventListener("change", function changeMicro() {
		threadSwatchState.clear();
		const swatchElements = selectAllElements(SWATCH_THREADS);
		swatchElements.forEach((swatchElement) => {
			swatchElement.classList.remove("selected");
		});
		jQuery(`${SWATCH_THREADS_MINUS_OUTLINE}.pplr_White`).trigger("click");
		jQuery(`${OUTLINE_REMOVE_BUTTON}`).trigger("click");
		if (threeD) threeD.style.display = "flex";
	});

	for (const thread of threads) {
		thread.addEventListener("click", function clickThread(e) {
			const currentElement = e.target as HTMLSpanElement;
			const parentParentElementClassList = currentElement.parentElement?.parentElement?.classList;
			const parentParentIdentifierClass = parentParentElementClassList?.item(
				parentParentElementClassList.length - 1,
			);
			// There is a bug. This only works if they click on different colors. If they click on the same color, it doesn't work. So we need to save the old color name and compare it to the new color name. If they are the same we do nothing.
			if (
				prevColorName === currentElement.dataset["name"] &&
				prevIdentifierClass === parentParentIdentifierClass
			) {
				return;
			}
			if (
				currentElement.dataset["name"] === "Metalic Gold" ||
				currentElement.dataset["name"] === "Metalic Silver"
			) {
				// If it's clicked I need to add to the map the parentParentIdentifierClass as key and the color name as value. Next, I need to check if the parentParentIDentifier class and its value are in the map. If they are, I need to delete them from the map, otherwise add them to the map.
				if (
					threadSwatchState.has(parentParentIdentifierClass) &&
					threadSwatchState.get(parentParentIdentifierClass) === currentElement.dataset["name"]
				) {
					// I need to check if the value of the is the same as the currentElement.dataset['name']. If it is, I need to remove it from the map.
					threadSwatchState.delete(parentParentIdentifierClass);
				} else {
					threadSwatchState.set(parentParentIdentifierClass, currentElement.dataset["name"]);
				}
			} else {
				threadSwatchState.delete(parentParentIdentifierClass);
			}
			// Every time we click on the color we need to check if the state map threadSwatchState has a size greater than 0. If it does then we need to hide the threeD element. If it doesn't then we need to show the threeD element.
			if (threadSwatchState.size > 0) {
				// We need to hide the threeD element, as well as unclick the threeD input element.
				const threeDInput = selectSingleElement<HTMLInputElement>(THREED_LIFT_TEN_INPUT);
				if (threeDInput) threeDInput.checked = false;
				if (threeD) threeD.style.display = "none";
			} else if (threeD) {
				threeD.style.display = "flex";
			}

			prevColorName = currentElement.dataset["name"] ?? "";
			prevIdentifierClass = parentParentIdentifierClass ?? "";
		});
	}
}
export default swatchThreadsSetup;
